/**
 * VerificationMethodSelector — FE-W-06.
 *
 * DNS TXT vs MX OTP toggle. 선택 lock (변경 시 confirm — 본 cycle 단순화: confirm 없이 reset).
 */

import { useSyncExternalStore } from 'react';
import type { VerifyMethod } from '../../../api/onboarding';
import { tOnb, getOnboardingLang, subscribeOnboardingLang } from '../../../lib/onboarding-i18n';

export function VerificationMethodSelector({
  method,
  onChange,
  disabled,
}: {
  method: VerifyMethod;
  onChange: (m: VerifyMethod) => void;
  disabled?: boolean;
}) {
  useSyncExternalStore(subscribeOnboardingLang, getOnboardingLang, getOnboardingLang);
  // Phase 4 CRITICAL-2 — production raw OTP 인터페이스가 본 cycle 미구현
  // (onboarding-smtp-probe 의 status='ok' branch 가 raw OTP 미반환).
  // MX-OTP UI 임시 disable + dev bypass 모드 (ONBOARDING_SMTP_BYPASS=true) 만 활성.
  // Phase 2a-2 cycle 에서 SMTP gateway integration 완료 후 재활성.
  const mxOtpDisabled = true;
  return (
    <div role="radiogroup" aria-label={tOnb('onboarding.method.aria_radiogroup')} style={{ display: 'flex', gap: '0.5rem', marginBottom: '1rem' }}>
      {(['dns_txt', 'mx_otp'] as const).map((m) => {
        const isMxDisabled = m === 'mx_otp' && mxOtpDisabled;
        return (
          <button
            key={m}
            type="button"
            role="radio"
            aria-checked={method === m}
            disabled={disabled || isMxDisabled}
            onClick={() => !isMxDisabled && onChange(m)}
            className={`onboarding-step__button onboarding-step__button--${
              method === m ? 'primary' : 'secondary'
            }`}
            style={{ flex: 1, fontSize: '0.875rem' }}
            title={isMxDisabled ? tOnb('onboarding.method.mx_disabled_title') : undefined}
          >
            {m === 'dns_txt' ? tOnb('onboarding.method.dns') : tOnb('onboarding.method.mx_coming_soon')}
          </button>
        );
      })}
    </div>
  );
}
